const state = {
  toggle: false,
  toggleMerchantModal: false,
  toggleOutletModal: false,
  toggleCropperModal: false,
  toggleFilterModal: false,
  toggleInfoModal: false,
  toggleOfferModal: false
};

const mutations = {
  setToggle(state) {
    state.toggle = !state.toggle;
  },

  setMerchantModal(state) {
    state.toggleMerchantModal = !state.toggleMerchantModal;
  },

  setOutletModal(state) {
    state.toggleOutletModal = !state.toggleOutletModal;
  },

  setCropperModal(state) {
    state.toggleCropperModal = !state.toggleCropperModal;
  },

  setFilterModal(state) {
    state.toggleFilterModal = !state.toggleFilterModal;
  },

  setInfoModal(state) {
    state.toggleInfoModal = !state.toggleInfoModal;
  },

  setOfferModal(state) {
    state.toggleOfferModal = !state.toggleOfferModal;
  }
};

const actions = {
  switchToggle({ commit }) {
    commit("setToggle");
  },

  merchantModalState: ({ commit }) => commit("setMerchantModal"),
  outletModalState: ({ commit }) => commit("setOutletModal"),
  cropperModalState: ({ commit }) => commit("setCropperModal"),
  filterModalState: ({ commit }) => commit("setFilterModal"),
  infoModalState: ({ commit }) => commit("setInfoModal"),
  offerModalState: ({ commit }) => commit("setOfferModal")
};

export const ui = {
  namespaced: true,
  state,
  actions,
  mutations
};
